// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const aromatisse: PokeData = {
  "id": 683,
  "name": "aromatisse",
  "height": 8,
  "weight": 155,
  "base_experience": 162,
  "types": [
    PokeType.FAIRY
  ],
  "api_moves": [
    "psychic",
    "reflect",
    "flail",
    "sweet-kiss",
    "charm",
    "attract",
    "sweet-scent",
    "psych-up",
    "skill-swap",
    "aromatherapy",
    "odor-sleuth",
    "calm-mind",
    "echoed-voice",
    "heal-pulse",
    "disarming-voice",
    "draining-kiss",
    "misty-terrain",
    "fairy-wind",
    "moonblast",
    "aromatic-mist"
  ],
  "moves": [
    "psychic",
    "reflect",
    "sweet-kiss",
    "aromatherapy",
    "calm-mind",
    "misty-terrain",
    "moonblast",
    "play-rough",
    "moonlight",
    "hyper-voice",
    "spirit-break",
    "heal-bell",
    "guardian-bond"
  ],
  "evolution_chain": {
    "id": 350,
    "item": null,
    "species": [
      {
        "name": "spritzee",
        "order": 683,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "aromatisse",
        "order": 684,
        "types": [
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 682,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.TRADE
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 166,
    "speed": 53,
    "ability_power": 181
  },
  "stat_changes": [],
  "catch_rate": 140,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
